export default __webpack_public_path__ + "static/media/image-3.a9c2003c.png";